import apiurl from './apiurl';
import axios from 'axios';

const authHeaders = (idToken) => ({
    'Content-Type': 'application/json',
    'Authorization': 'Bearer ' + idToken
});

// GET /padronSii/panel?ambiente=palena|maullin
// { ambiente, breaker, ultimaDescarga, indice }
export const obtenerPanel = async (idToken, ambiente) => {
    try {
        return await axios({
            method: 'GET',
            url: apiurl + 'padronSii/panel',
            headers: authHeaders(idToken),
            params: { ambiente },
        });
    } catch (error) {
        console.error('Error al obtener el panel del padrón:', error);
        throw error;
    }
};

// GET /padronSii/receptor?rut=12345678 — busca en el padrón COMPLETO (con overrides),
// no solo en el delta de un plan cargado en memoria.
export const buscarReceptor = async (idToken, rut) => {
    try {
        return await axios({
            method: 'GET',
            url: apiurl + 'padronSii/receptor',
            headers: authHeaders(idToken),
            params: { rut },
        });
    } catch (error) {
        console.error('Error al buscar el receptor:', error);
        throw error;
    }
};

// GET /padronSii/planes/{planId} — el plan completo (altas/bajas/cambios/muestras)
export const obtenerPlanDetalle = async (idToken, planId) => {
    try {
        return await axios({
            method: 'GET',
            url: apiurl + 'padronSii/planes/' + planId,
            headers: authHeaders(idToken),
        });
    } catch (error) {
        console.error('Error al obtener el plan:', error);
        throw error;
    }
};

// --- Acto 1: descargar ------------------------------------------------------
export const crearJobDescarga = async (idToken, { ambiente }) => {
    try {
        return await axios({
            method: 'POST',
            url: apiurl + 'padronSii/descargar/jobs',
            headers: authHeaders(idToken),
            data: { ambiente },
        });
    } catch (error) {
        console.error('Error al crear el job de descarga:', error);
        throw error;
    }
};
export const getJobDescarga = async (idToken, jobId) => {
    try {
        return await axios({
            method: 'GET',
            url: apiurl + 'padronSii/descargar/jobs/' + jobId,
            headers: authHeaders(idToken),
        });
    } catch (error) {
        console.error('Error al consultar el job de descarga:', error);
        throw error;
    }
};

// --- Acto 2: plan ------------------------------------------------------------
export const crearJobPlan = async (idToken, { ambiente, csvKey }) => {
    try {
        return await axios({
            method: 'POST',
            url: apiurl + 'padronSii/plan/jobs',
            headers: authHeaders(idToken),
            data: { ambiente, csvKey },
        });
    } catch (error) {
        console.error('Error al crear el job de plan:', error);
        throw error;
    }
};
export const getJobPlan = async (idToken, jobId) => {
    try {
        return await axios({
            method: 'GET',
            url: apiurl + 'padronSii/plan/jobs/' + jobId,
            headers: authHeaders(idToken),
        });
    } catch (error) {
        console.error('Error al consultar el job de plan:', error);
        throw error;
    }
};

// --- Acto 3: aplicar (siempre requiere click humano) -------------------------
export const crearJobAplicar = async (idToken, { planId, forzar }) => {
    try {
        return await axios({
            method: 'POST',
            url: apiurl + 'padronSii/aplicar/jobs',
            headers: authHeaders(idToken),
            data: { planId, forzar: forzar === true },
        });
    } catch (error) {
        console.error('Error al crear el job de aplicar:', error);
        throw error;
    }
};
export const getJobAplicar = async (idToken, jobId) => {
    try {
        return await axios({
            method: 'GET',
            url: apiurl + 'padronSii/aplicar/jobs/' + jobId,
            headers: authHeaders(idToken),
        });
    } catch (error) {
        console.error('Error al consultar el job de aplicar:', error);
        throw error;
    }
};

// --- Circuit breaker -----------------------------------------------------
export const reanudarBreaker = async (idToken, { ambiente }) => {
    try {
        return await axios({
            method: 'POST',
            url: apiurl + 'padronSii/breaker/reanudar',
            headers: authHeaders(idToken),
            data: { ambiente },
        });
    } catch (error) {
        console.error('Error al reanudar el breaker:', error);
        throw error;
    }
};
export const setModoBreaker = async (idToken, { ambiente, modo }) => {
    try {
        return await axios({
            method: 'POST',
            url: apiurl + 'padronSii/breaker/modo',
            headers: authHeaders(idToken),
            data: { ambiente, modo },
        });
    } catch (error) {
        console.error('Error al cambiar el modo del breaker:', error);
        throw error;
    }
};
